/**
 * Cookies Banner Component.
 */

import whatInput from 'what-input';
import { Component } from 'js-component-framework';

/**
 * CookiesBanner Class
 */
export default class CookiesBanner extends Component {
  /**
   * Start the component.
   */
  constructor(config) {
    super(config);

    const {
      dismiss,
      header,
      nextFocusItem,
    } = this.children;

    // Exit early.
    if (! dismiss || ! header || ! nextFocusItem) {
      return;
    }

    this.ccDismiss = this.ccDismiss.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    dismiss.addEventListener('click', this.ccDismiss);

    if (null === window.localStorage.getItem('aam_cookie_accept')) {
      this.element.classList.remove('hidden');
      // a11y - When the page loads, the keyboard focus to be set on the header.
      // We have hacked this to allow it to recieve focus by using tabindex=-1
      // on the element at Sina's suggestion.
      header.focus();

      // a11y - The escape key should activate the dismiss button.
      document.addEventListener('keydown', this.handleKeydown);
    }
  }

  /**
   * Fire ccDismiss when escape key is pressed.
   *
   * @param {object} event Keydown event.
   */
  handleKeydown(event) {
    if ('Escape' === event.key || 27 === event.keyCode) {
      this.ccDismiss();
    }
  }

  /**
   * Close cookie modal and set local storage so that
   * modal does not appear again.
   */
  ccDismiss() {
    this.element.remove();
    window.localStorage.setItem('aam_cookie_accept', '1');

    if ('keyboard' === whatInput.ask()) {
      this.children.nextFocusItem.focus();
    }

    // No longer listen for escape key.
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
